import { api } from './api';

const getAll = async () => {
  try {
    const { data } = await api.get(`/v2/activation/formatCpm`);
    return data;
  } catch (err) {
    console.error(err);
    return [];
  }
};
const update = async (id, datas) => {
  try {
    const { data } = await api.put(`/v2/activation/formatCpm/${id}`, datas);
    return data;
  } catch (err) {
    console.error(err);
    return null;
  }
};

const create = async datas => {
  try {
    const { data } = await api.post(`/v2/activation/formatCpm`, datas);
    return data;
  } catch (err) {
    console.error(err);
    return null;
  }
};

const deleteOne = async id => {
  try {
    const { data } = await api.delete(`/v2/activation/formatCpm/${id}`);
    return data;
  } catch (err) {
    console.error(err);
    return {};
  }
};

const duplicate = async datas => {
  try {
    const { data } = await api.post(
      `/v2/activation/formatCpm/duplicate`,
      datas
    );
    return data;
  } catch (err) {
    console.error(err);
    return {};
  }
};

export default { getAll, create, update, deleteOne, duplicate };
